import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = /*#__PURE__*/ _createElementVNode("i", {
    class: "icon icon-checked-60px",
    "aria-hidden": "true"
}, null, -1);
const _hoisted_2 = ["innerHTML"];
const _hoisted_3 = { class: "dialog" };
import { computed } from 'vue';
import { useStore } from 'vuex';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ModalExportSuccess',
    props: {
        modelValue: { type: Boolean }
    },
    emits: ['update:modelValue'],
    setup(__props, { emit }) {
        const props = __props;
        const store = useStore();
        const isVisible = computed({
            get: () => props.modelValue,
            set: value => emit('update:modelValue', value),
        });
        const close = () => {
            isVisible.value = false;
            store.commit('audienceManager/ACTIVATE_EXPORTATION_AUDIENCE_MODAL', false);
        };
        return (_ctx, _cache) => {
            const _component_el_dialog = _resolveComponent("el-dialog");
            return (_openBlock(), _createBlock(_component_el_dialog, {
                modelValue: isVisible.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((isVisible).value = $event)),
                class: "modal-export-success",
                "append-to-body": "",
                "close-on-click-modal": false,
                "close-on-press-escape": false,
                "show-close": false,
                width: "500"
            }, {
                default: _withCtx(() => [
                    _hoisted_1,
                    _createElementVNode("p", {
                        class: "modal-export-success__description",
                        innerHTML: _ctx.$t('audiences.exportation.success')
                    }, null, 8, _hoisted_2),
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", {
                            class: "btn modal-export-success__btn-confirm",
                            onClick: close
                        }, _toDisplayString(_ctx.$t('continue')), 1)
                    ])
                ]),
                _: 1
            }, 8, ["modelValue"]));
        };
    }
});
